import { NotificationDropdown } from "@/components/notifications/NotificationDropdown";
import { User } from "@supabase/supabase-js";
import { Logo } from "@/components/ui/Logo";
import { ThemeToggle } from "@/components/ui/theme-toggle";
import { CommandBar } from "@/components/CommandBar";
import { Command } from "lucide-react";

interface MobileHeaderProps {
  user: User;
  organizationId: string;
}

export function MobileHeader({ user, organizationId }: MobileHeaderProps) {
  return (
    <>
      <header className="sticky top-0 z-40 glass-strong border-b border-border/30 md:hidden">
        <div className="flex h-14 items-center justify-between px-4">
          <Logo size="sm" />
          
          <div className="flex items-center gap-1">
            {/* Cmd+K trigger for mobile */}
            <button
              onClick={() => {
                const event = new KeyboardEvent('keydown', {
                  key: 'k',
                  metaKey: true,
                  bubbles: true,
                });
                document.dispatchEvent(event);
              }}
              className="flex items-center justify-center h-8 w-8 rounded-lg hover:bg-muted transition-colors"
            >
              <Command className="h-4 w-4 text-muted-foreground" />
            </button>
            <ThemeToggle />
            <NotificationDropdown userId={user.id} organizationId={organizationId} />
          </div>
        </div>
      </header>
      
      {/* Command Bar */}
      <CommandBar organizationId={organizationId} />
    </>
  );
}
